// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1jzIy","inner":"Form_inner__3-cbG","range":"Form_range__37L6i","name":"Form_name__CM3ux","actions":"Form_actions__14pkJ"};